import { Injectable } from '@angular/core';
import { EtxIcon } from './etx-icons.model';

@Injectable({
  providedIn: 'root'
})
export class EtxIconsRegistryService {
  private registry = new Map<string, string>();

  public registerIcons(icons: EtxIcon[]): void {
    icons.forEach((icon: EtxIcon) => this.registry.set(icon.name, icon.data));
  }

  public getIcon(iconName: string): string | undefined {
    if (!this.registry.has(iconName)) {
      console.warn(
        `We could not find the EtxStudio Icon with the name ${iconName}, did you add it to the Icon registry?`
      );
    }
    return this.registry.get(iconName);
  }
}
